class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    if(this.querySelector('button[type="button"]')){
      this.querySelector('button[type="button"]').addEventListener(
        'click',
        this.close.bind(this)
      );
    }
   

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    if(this.classList.contains('header__search')){
      let headerElem = document.querySelector('sticky-header');
      if(headerElem){
        headerElem.closeNav();
        // The panel starts where the bar ends, announcement bar or not (STR-1427).
        if (typeof headerElem.setBottom === 'function') headerElem.setBottom();

        let megaMenus = document.querySelectorAll('.mega-menu-new');
        let megaMenuBtn = document.querySelectorAll('[data-open-mega-menu]');
        megaMenus.forEach((menu)=>{
          document.body.classList.remove('overflow-off');
          menu.classList.remove('open');
          megaMenuBtn.forEach((btn)=>{
              btn.classList.remove('open');
          })
          headerElem.classList.remove('open');
          headerElem.classList.remove('remove-blur');
      })
      }
      document.body.classList.add('search-open');
      document.querySelector('html').style.overflow = 'hidden';
      let stickyHeader = document.querySelector('sticky-header');
      if(stickyHeader){
        stickyHeader.classList.toggle('open');
        stickyHeader.classList.toggle('remove-blur');
      }   
    }
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    // STR-1392: the icon is a toggle; its underline and screen readers read this.
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    let focusTarget = focusToggle ? this.summaryToggle : null;
    // Below 750 the search icon is hidden (search opens from the drawer), so focus
    // returns to the menu button instead of being dropped (STR-1427).
    if (focusTarget && focusTarget.offsetParent === null && this.classList.contains('header__search')) {
      focusTarget = document.querySelector('sticky-header [data-menu-toggle]');
    }
    removeTrapFocus(focusTarget);
    this.detailsContainer.removeAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if(this.classList.contains('header__search')){
      document.querySelector('html').style.overflow = '';
      document.body.classList.remove('search-open');
      let stickyHeader = document.querySelector('sticky-header');
      if(stickyHeader){
        stickyHeader.classList.remove('open');
        stickyHeader.classList.remove('remove-blur');
      }   
    }
  }
}

customElements.define('details-modal', DetailsModal);
